import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, {
    class: ["cursor-pointer", _ctx.classNames]
  }), [
    _createVNode(_component_SvgIcon, {
      size: _ctx.size,
      type: "mdi",
      path: _ctx.path
    }, null, 8, ["size", "path"])
  ], 16))
}